"use strict";
exports.__esModule = true;
exports.VgsFormFieldName = void 0;
var VgsFormFieldName;
(function (VgsFormFieldName) {
    VgsFormFieldName["BillingAddress"] = "variables.cardData.billingAddress";
    VgsFormFieldName["Expiration"] = "variables.cardData";
    VgsFormFieldName["Number"] = "variables.cardData.number";
    VgsFormFieldName["CVC"] = "variables.cardData.cvv";
})(VgsFormFieldName = exports.VgsFormFieldName || (exports.VgsFormFieldName = {}));
